/**
 * Avatar do usuário gerado pelo DiceBear — mesmo provider usado no Sischef.
 * Estilo "bottts", seed = e-mail do usuário (normalizado), então o mesmo
 * usuário tem sempre o mesmo robô.
 *
 * Ex.: https://api.dicebear.com/7.x/bottts/svg?seed=fulano@email.com
 */
export function urlAvatarUsuario(email: string | null | undefined): string {
  const seed = encodeURIComponent((email ?? 'sischef').trim().toLowerCase());
  return `https://api.dicebear.com/7.x/bottts/svg?seed=${seed}`;
}
